module.exports = __webpack_public_path__ + "android-767e7463.png";